  // Angular
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {CookieService} from "ngx-cookie-service";
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// RxJS
//import 'rxjs/add/operator/timeout';

/**
 * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
 */
@Injectable()
export class InterceptService implements HttpInterceptor {
  private sessionExpiredHandled = false;

  constructor(public cookieService: CookieService, private router: Router,
              private matSnackBar: MatSnackBar, private modalService: NgbModal) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    const authToken = this.cookieService.get('X_TOKEN');
    if (authToken !== undefined && authToken !== null && authToken !== '') {
      const dt = this.addMinutes(new Date(), 60);
      this.cookieService.set('X_TOKEN', authToken,null,null,null,true,'Strict');
      const headers = req.headers.set('X_TOKEN', authToken);
      const authReq = req.clone({headers: headers, params: req.params});
      return next.handle(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 && !req.url.endsWith('/logout')) {
            this.logoutOnSessionExpired();
          }
          return throwError(error);
        })
      );
    }
    this.sessionExpiredHandled = false;
    return next.handle(req);

  }

  // A 401 on a request that carried a token means the token has expired or been revoked
  private logoutOnSessionExpired() {
    if (this.sessionExpiredHandled) {
      return;
    }
    this.sessionExpiredHandled = true;

    this.cookieService.deleteAll();
    this.modalService.dismissAll();
    this.matSnackBar.open('Your session has expired. Please sign in again.', 'Okay', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
    this.router.navigate(['/signin']);
  }

  public addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
}
